import { accessFunctions } from "../../shared/utilities/Constants";

// add required access function with default value to list
// response value can be retrieved from store by adding a selector to authorize reducer index
export const authorizeRequest: AuthorizeRequestType[] = [
  {
    accessFunction: accessFunctions.accessInitiateMoneyMovement,
    defaultTo: true
  },
  {
    accessFunction: accessFunctions.accessReleaseMoneyMovement,
    defaultTo: false
  },
  {
    accessFunction: accessFunctions.updateMoveMoney,
    defaultTo: false
  },
  {
    accessFunction: accessFunctions.viewMoveMoney,
    defaultTo: false
  },
  {
    accessFunction: accessFunctions.updateMoneyLink,
    defaultTo: false
  },
  {
    accessFunction: accessFunctions.requestWire,
    defaultTo: false
  },
  {
    accessFunction: accessFunctions.journalPositionLotSelection,
    defaultTo: false
  },
  {
    accessFunction: accessFunctions.editAchPhase2,
    defaultTo: false
  },
  {
    accessFunction: accessFunctions.accessDigitalToPdfTransactions,
    defaultTo: false
  },
  {
    accessFunction: accessFunctions.accessPositionLotsPhase2,
    defaultTo: false
  },
  {
    accessFunction: accessFunctions.moveMoneyShellFirms,
    defaultTo: false
  },
  {
    accessFunction: accessFunctions.ptrsViewFacility,
    defaultTo: false
  },
  {
    accessFunction: accessFunctions.accessPalWires,
    defaultTo: false
  },
  {
    accessFunction: accessFunctions.accessAchPath,
    defaultTo: false
  }
]

export type AuthorizeRequestType = {
  accessFunction: string;
  defaultTo: boolean;
}
